//@flow
//Core
import React, { useState } from 'react';
import get from 'lodash.get';
import { Container, Box } from '@material-ui/core';
import formatDate from 'date-format';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import imgNewsBanner from 'src/images/news-banner.png';

// //Local
import { Layout } from '../components';
import {
  BreadcrumbsSec,
  ArticleSec,
  AuthorSec,
  RecommendSec,
} from '../components/mediaCenterSections/article';
import { articleStyles } from '../styles/pages/media_center.styles';
import { filterRecommendedCardsForPublish } from '../components/mediaCenterSections/utils';
import { getOgData } from '../utils';

export const query = graphql`
  query($tagsId: [String], $contentfulId: String) {
    allContentfulComponentArticle(
      limit: 1000
      filter: {
        tags: { elemMatch: { id: { in: $tagsId } } }
        contentful_id: { ne: $contentfulId }
      }
    ) {
      edges {
        node {
          title
          contentful_id
          date
          blogSection {
            urlKey
          }
          previewImage {
            file {
              url
            }
          }
          tags {
            title
          }
        }
      }
    }
    site {
      siteMetadata {
        title
        ogImage
        twitterImage
        siteUrl
      }
    }
  }
`;

const Article = ({
  pageContext,
  data,
  location,
}: {
  pageContext: Object,
  data: Object,
  location: Object,
}) => {
  const styles = articleStyles();
  const [imgPopupState, setImgPopupState] = useState({
    isOpen: false,
    url: null,
  });

  const articleId = get(pageContext, 'contentfulId');
  const sessionUrl = get(pageContext, 'blogSection.urlKey');
  const breadcrumbs = [
    {
      title: 'トップ',
      url: '/',
    },
    {
      title: 'HRからのお知らせ',
      url: `/hr-blog/`,
    },
    {
      title: get(pageContext, 'title'),
    },
  ];
  const recommendedArticles = filterRecommendedCardsForPublish(
    get(data, 'allContentfulComponentArticle.edges', [])
  );

  const handleImgClick = (event) => {
    setImgPopupState({
      isOpen: true,
      url: event.target.src,
    });
  };

  const handleClosePopup = () => {
    setImgPopupState({
      isOpen: false,
      url: null,
    });
  };

  return (
    <Layout>
      <Helmet
        meta={getOgData({
          img: get(pageContext, 'previewImage'),
          title: get(pageContext, 'title'),
          siteMetadata: get(data, 'site.siteMetadata'),
        })}
      >
        {sessionUrl === 'fun' && (
          <meta
            httpEquiv="refresh"
            content={`0; url=/column/article/${articleId}`}
          />
        )}
      </Helmet>
      <Box className={styles.articlePage}>
        <Box
          className={styles.articlePageBg}
          style={{
            backgroundImage: `url(${imgNewsBanner})`,
          }}
        />
        <Container maxWidth="md">
          <Box className={styles.paper}>
            <BreadcrumbsSec
              items={breadcrumbs}
              tag={get(pageContext, 'tags[0]', {})}
            />
            <ArticleSec
              title={get(pageContext, 'title')}
              subtitle={get(pageContext, 'subtitle')}
              date={formatDate(
                'yyyy/MM/dd',
                new Date(
                  get(pageContext, 'date') || get(pageContext, 'createdAt')
                )
              )}
              author={get(pageContext, 'author')}
              tags={get(pageContext, 'tags', [])}
              content={get(pageContext, 'content.json')}
              imgPopupState={imgPopupState}
              handleImgClick={handleImgClick}
              handleClosePopup={handleClosePopup}
              shareUrl={location.href}
              sessionUrl={sessionUrl}
            />
            {get(pageContext, 'authorBlock') && (
              <AuthorSec
                image={get(pageContext, 'authorBlock.image.file.url')}
                name={get(pageContext, 'authorBlock.name')}
                surname={get(pageContext, 'authorBlock.surname')}
                jobTitle={get(pageContext, 'authorBlock.jobTitle')}
                description={get(pageContext, 'authorBlock.description')}
              />
            )}
            {!!recommendedArticles.length && (
              <RecommendSec recommendedArticles={recommendedArticles} />
            )}
          </Box>
        </Container>
      </Box>
    </Layout>
  );
};

export default Article;
